
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Les traductions
const resources = {
  fr: {
    translation: {
      // Navbar
      'nav.home': 'Accueil',
      'nav.services': 'Services',
      'nav.projects': 'Projets',
      'nav.expertises': 'Expertises',
      'nav.references': 'Références',
      'nav.contact': 'Contact',
      'nav.quote': 'Devis gratuit',

      // Hero
      'hero.badge': 'Depuis 2011 à Madagascar',
      'hero.title1': 'Votre véritable',
      'hero.title2': 'service auxiliaire',
      'hero.desc': 'Plus de 20 ans d\'expertise cumulée en ingénierie et construction. De la conception à la maintenance, nous vous accompagnons avec rigueur et transparence.',
      'hero.point1': 'Normes qualité & sécurité',
      'hero.point2': 'Réactivité 24/7',
      'hero.point3': 'Solutions sur mesure',
      'hero.point4': 'Expertise pluridisciplinaire',
      'hero.btnQuote': 'Demander un devis',
      'hero.btnServices': 'Nos services',
      
      // Hero Bottom Stats
      'hero.stat1Title': 'Génie Électrique',
      'hero.stat1Desc': 'Courants forts & faibles',
      'hero.stat2Title': 'Climatisation',
      'hero.stat2Desc': 'Confort thermique',
      'hero.stat3Title': 'Froid Industriel',
      'hero.stat3Desc': 'Solutions frigorifiques',

      // Services Section
      'services.sectionSubtitle': 'Nos Services',
      'services.sectionTitle': 'Une gamme complète de services d\'excellence',
      'services.sectionDesc': 'De la conception à la réalisation, nous répondons à vos attentes avec un niveau d\'excellence inégalé.',
      'services.learnMore': 'En savoir plus',
      
      'services.service1.title': 'Consultance en Bureau d’Études',
      'services.service1.desc': 'Analyse minutieuse de chaque aspect technique, économique et réglementaire pour des solutions sur mesure.',
      'services.service1.b1': 'Études préliminaires rigoureuses',
      'services.service1.b2': 'Solutions optimisées selon votre budget',
      'services.service1.b3': 'Conformité normative garantie',
      'services.service1.b4': 'Recommandations stratégiques',
      
      'services.service2.title': 'Installation & Réalisation',
      'services.service2.desc': 'Précision, qualité et respect des délais pour une installation conforme et fiable.',
      'services.service2.b1': 'Équipes techniques certifiées',
      'services.service2.b2': 'Planification détaillée',
      'services.service2.b3': 'Matériaux de première qualité',
      'services.service2.b4': 'Tests de performance systématiques',
      
      'services.service3.title': 'Suivi & Maintenance',
      'services.service3.desc': 'Maintenance préventive et réactive pour minimiser les risques et assurer un fonctionnement optimal.',
      'services.service3.b1': 'Plans de maintenance personnalisés',
      'services.service3.b2': 'Intervention rapide 24h/7j',
      'services.service3.b3': 'Prolongation durée de vie',
      'services.service3.b4': 'Rapports réguliers d’état',
      
      'services.service4.title': 'Audits & Optimisation',
      'services.service4.desc': 'Diagnostics techniques complets pour évaluer, identifier et améliorer vos installations.',
      'services.service4.b1': 'Diagnostics technologiques avancés',
      'services.service4.b2': 'Sources de pertes énergétiques identifiées',
      'services.service4.b3': 'Amélioration de performance chiffrée',
      'services.service4.b4': 'Analyses comparatives sectorielles',
      
      'services.service5.title': 'Formation Technique',
      'services.service5.desc': 'Formations pratiques pour renforcer les compétences de vos équipes dans tous nos domaines.',
      'services.service5.b1': 'Programmes sur mesure',
      'services.service5.b2': 'Sessions pratiques terrain',
      'services.service5.b3': 'Certification reconnue',
      'services.service5.b4': 'Support post-formation',
      
      'services.service6.title': 'Planification de Chantier',
      'services.service6.desc': 'Pilotage précis avec planification détaillée et transparence totale à chaque étape.',
      'services.service6.b1': 'Coordination optimale des intervenants',
      'services.service6.b2': 'Suivi en temps réel',
      'services.service6.b3': 'Gestion proactive des aléas',
      'services.service6.b4': 'Respect des budgets et délais',

      // Stats Section
      'stats.label1': 'Ans d\'expertise technique',
      'stats.label2': 'Projets réalisés',
      'stats.label3': 'Collaborateurs',
      'stats.label4': 'Satisfaction client',
      'stats.marquee1': 'ELECTRICITÉ',
      'stats.marquee2': 'RÉHABILITATION',
      'stats.marquee3': 'CLIMATISATION',
      'stats.marquee4': 'FROID INDUSTRIEL',
      'stats.marquee5': 'PLOMBERIE',
      'stats.marquee6': 'ÉNERGIES RENOUVELABLES',
      'stats.marquee7': 'MENUISERIE',
      'stats.marquee8': 'DOMOTIQUE',

      // Expertises Section
      'expertises.tag': 'Nos Domaines d\'Intervention',
      'expertises.title1': 'L\'Excellence Technique',
      'expertises.title2': 'Au Service de Vos Projets',
      'expertises.desc': 'Une maîtrise complète des lots techniques pour garantir performance, sécurité et durabilité à vos infrastructures.',
      'expertises.learnMore': 'En savoir plus',
      'expertises.close': 'Fermer',
      'expertises.modalTitle': 'Services & Prestations',
      'expertises.quote': 'Demander un devis pour ce service',

      // Why Choose Us
      'whyChooseUs.tag': 'Pourquoi Auxis',
      'whyChooseUs.title': 'Pourquoi nous choisir ?',
      'whyChooseUs.subtitle': 'Nous combinons expertise technique, réactivité et engagement qualité pour garantir la réussite de chaque intervention.',
      'whyChooseUs.contact': 'Contactez notre équipe',
      'whyChooseUs.learnMore': 'En savoir plus',
      'whyChooseUs.seeLess': 'Voir moins',
      'whyChooseUs.reason1.title': 'Expertise Polyvalente',
      'whyChooseUs.reason1.desc': 'Solutions complètes pour tous vos besoins techniques',
      'whyChooseUs.reason1.p1': 'Multi-spécialistes : Électricité, plomberie, climatisation, menuiserie, froid industriel et énergies renouvelables',
      'whyChooseUs.reason1.p2': 'Bureaux d’études intégrés pour chaque domaine',
      'whyChooseUs.reason2.title': 'Flexibilité & Réactivité',
      'whyChooseUs.reason2.desc': 'Disponibles quand vous en avez besoin',
      'whyChooseUs.reason2.p1': 'Aptitude aux travaux dans les périodes non ouvrables',
      'whyChooseUs.reason2.p2': 'Interventions 24h/24 pour les urgences',
      'whyChooseUs.reason2.p3': 'Suivi post-installation personnalisé',
      'whyChooseUs.reason3.title': 'Qualité Garantie',
      'whyChooseUs.reason3.desc': 'Excellence à chaque étape de votre projet',
      'whyChooseUs.reason3.p1': 'Matériaux haut de gamme',
      'whyChooseUs.reason3.p2': 'Suivi qualité à chaque étape du projet',
      'whyChooseUs.reason3.p3': 'Garanties étendues sur les installations',

      // References Section
      'references.tag': 'Références',
      'references.title': 'Ils nous font confiance',
      'references.subtitle': 'Des entreprises et institutions de premier plan à Madagascar.',
      'references.tagline': 'L\'excellence en services d\'ingénierie depuis 2011',
      'references.about': 'À propos',
      'references.close': 'Fermer',

      'references.ref1.nom': 'Nations Unies',
      'references.ref1.desc': 'Prestataire de services depuis 2019',
      'references.ref1.detailed': 'Prestataire de services pour les Nations Unies depuis 2019, Auxis contribue activement à l\'entretien des bâtiments et à la préservation des biens de l\'organisation.',
      'references.ref1.type': 'Axes de travaux',
      'references.ref1.t1': 'Interventions rapides pour maintenances curatives',
      'references.ref1.t2': 'Maintenances préventives',
      'references.ref1.t3': 'Conception et installation',
      'references.ref1.t4': 'Rénovation et aménagement intérieur',
      'references.ref1.t5': 'Suivi et conseils',

      'references.ref2.nom': 'BAMADA & SODIAMA',
      'references.ref2.desc': 'Concessionnaires automobiles',
      'references.ref2.detailed': 'AUXIS intervient en tant qu\'installateur et maintenancier électrique dans les infrastructures de ces deux leaders du secteur automobile à Madagascar.',
      'references.ref2.type': 'Réalisations',
      'references.ref2.t1': 'Installation inverseur de source « 3 en 1 »',
      'references.ref2.t2': 'Maintenance préventive régulière',
      'references.ref2.t3': 'Réseau ondulé - Protection équipements',

      'references.ref3.nom': 'Direction Générale des Impôts',
      'references.ref3.desc': 'Aménagement de locaux',
      'references.ref3.detailed': 'Auxis prend part à l\'installation des systèmes de climatisation au sein du local de la DGI à Anosy.',
      'references.ref3.type': 'Réalisation',
      'references.ref3.t1': 'Mise en place d\'un système de climatisation split dans l\'open space',

      'references.ref4.nom': 'SOMACOU',
      'references.ref4.desc': 'Concepteur et installateur électrique',
      'references.ref4.detailed': 'Auxis agit en tant que concepteur et installateur électrique pour SOMACOU.',
      'references.ref4.type': 'Réalisation',
      'references.ref4.t1': 'Installation de paratonnerres',
      'references.ref4.t2': 'Résolution vulnérabilité foudre',
      'references.ref4.t3': 'Protection des infrastructures',

      // Rest of the old translations
      'accueil': 'Accueil',
      'services': 'Services',
      'projets': 'Projets',
      'contact': 'Contact',
      'excellence': 'Excellence en',
      'ingenierie': 'Ingénierie & Construction',
      'solutions': 'Solutions innovantes en construction, génie climatique et froid industriel à Madagascar.',
      'commencer': 'Commencer',
      'nosServices': 'Nos Services',
      'servicesDesc': 'Nous offrons une gamme complète de services d\'ingénierie et de construction adaptés à vos besoins.',
      'construction': 'Construction',
      'constructionDesc': 'Solutions de construction innovantes et durables pour tous types de projets.',
      'climatique': 'Génie Climatique',
      'climatiqueDesc': 'Systèmes de climatisation et de ventilation performants et économes en énergie.',
      'industriel': 'Froid Industriel',
      'industrielDesc': 'Solutions de réfrigération industrielle sur mesure pour les entreprises.',
      'nosProjets': 'Nos Projets',
      'projetsDesc': 'Découvrez nos réalisations les plus récentes et notre expertise dans divers domaines.',
      'projet': 'PROJET',
      'projet1': 'Centre Commercial',
      'projet1Desc': 'Construction et installation complète des systèmes CVC.',
      'projet2': 'Site Industriel',
      'projet2Desc': 'Conception et installation de systèmes de réfrigération industrielle.',
      'projet3': 'Bâtiment Administratif',
      'projet3Desc': 'Solutions d\'efficacité énergétique pour bâtiments de bureaux.',
      
      // Footer and Contact section (if not yet added, using robust unique keys)
      'contactSection.title': 'Contactez-Nous',
      'contactSection.description': 'Entrez en contact avec notre équipe pour toute demande ou discussion de projet',
      'contactSection.info.title': 'Informations de contact',
      'contactSection.info.address.title': 'Adresse',
      'contactSection.info.address.value': 'Lot II A 28 PZ Amboditsiry, Antananarivo, Madagascar',
      'contactSection.info.phone.title': 'Téléphone',
      'contactSection.info.phone.value': '+261 34 08 866 86',
      'contactSection.info.email.title': 'Email',
      'contactSection.info.email.value': 'services@auxis.mg',
      'contactSection.form.title': 'Envoyez-nous un message',
      'contactSection.form.name.label': 'Nom',
      'contactSection.form.name.placeholder': 'Votre Nom',
      'contactSection.form.email.label': 'Email',
      'contactSection.form.email.placeholder': 'Votre Email',
      'contactSection.form.subject.label': 'Sujet',
      'contactSection.form.subject.placeholder': 'Comment pouvons-nous vous aider ?',
      'contactSection.form.message.label': 'Message',
      'contactSection.form.message.placeholder': 'Votre Message',
      'contactSection.form.submit': 'Envoyer le Message',
      'contactSection.form.sending': 'Envoi en cours...',
      'contactSection.form.successTitle': 'Message Envoyé!',
      'contactSection.form.successMessage': 'Merci de nous avoir contacté. Nous vous répondrons dans les plus brefs délais.',

      // Footer
      'footer.description': 'Ingénierie, conception et réalisation de travaux spécialisés : Génie climatique, ingénierie électrique, fluides, et bâtiment général.',
      'footer.navigation': 'Navigation',
      'footer.contact.title': 'Contact',
      'footer.newsletter.title': 'Restez Informé',
      'footer.newsletter.description': 'Inscrivez-vous à notre newsletter pour recevoir nos dernières actualités.',
      'footer.newsletter.placeholder': 'Votre adresse email',
      'footer.newsletter.button': 'S\'abonner',
      'footer.company.title': 'Entreprise',
      'footer.company.services': 'Services',
      'footer.company.projects': 'Projets',
      'footer.company.contact': 'Contact',
      'footer.legal.title': 'Légal',
      'footer.legal.privacy': 'Confidentialité',
      'footer.legal.terms': 'Mentions Légales',
      'footer.rights': 'Tous droits réservés.',
      'footer.privacy': 'Politique de Confidentialité',
      'footer.devBy': 'Développé par',

      // Confidentialite
      'confidentialite.back': 'Retour à l\'accueil',
      'confidentialite.title': 'Politique de Confidentialité',
      'confidentialite.updated': 'Dernière mise à jour :',
      'confidentialite.s1.title': '1. Collecte des données',
      'confidentialite.s1.content': 'Nous collectons les informations que vous nous fournissez directement lorsque vous utilisez notre formulaire de contact, notamment votre nom, votre adresse e-mail et le contenu de votre message.',
      'confidentialite.s2.title': '2. Utilisation des données',
      'confidentialite.s2.content': 'Les informations que nous collectons sont utilisées exclusivement pour :',
      'confidentialite.s2.l1': 'Répondre à vos demandes de renseignements ou de devis',
      'confidentialite.s2.l2': 'Améliorer notre service client',
      'confidentialite.s2.l3': 'Vous contacter concernant votre projet',
      'confidentialite.s3.title': '3. Protection des données',
      'confidentialite.s3.content': 'Nous mettons en œuvre une variété de mesures de sécurité pour préserver la sécurité de vos informations personnelles. Vos données ne seront ni vendues, ni échangées, ni transférées, ni données à une autre société sans votre consentement.',
      'confidentialite.s4.title': '4. Contact',
      'confidentialite.s4.content': 'Pour toute question concernant cette politique de confidentialité, vous pouvez nous contacter à l\'adresse :',

      // Mentions Legales
      'mentions.back': 'Retour à l\'accueil',
      'mentions.title': 'Mentions Légales',
      'mentions.updated': 'Dernière mise à jour :',
      'mentions.s1.title': '1. Éditeur du site',
      'mentions.s1.p1': 'Le site ',
      'mentions.s1.p2': ' est édité par la société AUXIS.',
      'mentions.s1.siege': 'Siège social :',
      'mentions.s1.siegeValue': 'Lot II A 28 PZ Amboditsiry, Antananarivo, Madagascar',
      'mentions.s1.email': 'Email :',
      'mentions.s1.emailValue': 'services@auxis.mg',
      'mentions.s1.tel': 'Téléphone :',
      'mentions.s1.telValue': '+261 34 08 866 86',
      'mentions.s2.title': '2. Propriété intellectuelle',
      'mentions.s2.content': 'L\'ensemble de ce site relève de la législation malgache et internationale sur le droit d\'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.',
      'mentions.s3.title': '3. Limitation de responsabilité',
      'mentions.s3.content': 'AUXIS s\'efforce d\'assurer au mieux de ses possibilités, l\'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, AUXIS décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site.',
      'mentions.s4.title': '4. Hébergement',
      'mentions.s4.content': 'Ce site est hébergé par InMotion Hosting.'
    }
  },
  en: {
    translation: {
      // Navbar
      'nav.home': 'Home',
      'nav.services': 'Services',
      'nav.projects': 'Projects',
      'nav.expertises': 'Expertises',
      'nav.references': 'References',
      'nav.contact': 'Contact',
      'nav.quote': 'Free quote',

      // Hero
      'hero.badge': 'Since 2011 in Madagascar',
      'hero.title1': 'Your true',
      'hero.title2': 'auxiliary service',
      'hero.desc': 'More than 20 years of combined expertise in engineering and construction. From design to maintenance, we support you with rigor and transparency.',
      'hero.point1': 'Quality & Safety Standards',
      'hero.point2': '24/7 Responsiveness',
      'hero.point3': 'Custom Solutions',
      'hero.point4': 'Multidisciplinary Expertise',
      'hero.btnQuote': 'Request a quote',
      'hero.btnServices': 'Our services',

      // Hero Bottom Stats
      'hero.stat1Title': 'Electrical Engineering',
      'hero.stat1Desc': 'High & Low Voltage',
      'hero.stat2Title': 'Air Conditioning',
      'hero.stat2Desc': 'Thermal Comfort',
      'hero.stat3Title': 'Industrial Refrigeration',
      'hero.stat3Desc': 'Refrigeration Solutions',

      // Services Section
      'services.sectionSubtitle': 'Our Services',
      'services.sectionTitle': 'A comprehensive range of excellent services',
      'services.sectionDesc': 'From design to execution, we meet your expectations with an unparalleled level of excellence.',
      'services.learnMore': 'Learn more',
      
      'services.service1.title': 'Consulting Engineering',
      'services.service1.desc': 'Meticulous analysis of every technical, economic, and regulatory aspect for tailor-made solutions.',
      'services.service1.b1': 'Rigorous preliminary studies',
      'services.service1.b2': 'Solutions optimized for your budget',
      'services.service1.b3': 'Guaranteed regulatory compliance',
      'services.service1.b4': 'Strategic recommendations',
      
      'services.service2.title': 'Installation & Execution',
      'services.service2.desc': 'Precision, quality, and adherence to deadlines for a compliant and reliable installation.',
      'services.service2.b1': 'Certified technical teams',
      'services.service2.b2': 'Detailed planning',
      'services.service2.b3': 'Premium quality materials',
      'services.service2.b4': 'Systematic performance testing',
      
      'services.service3.title': 'Monitoring & Maintenance',
      'services.service3.desc': 'Preventive and reactive maintenance to minimize risks and ensure optimal operation.',
      'services.service3.b1': 'Customized maintenance plans',
      'services.service3.b2': 'Rapid response 24/7',
      'services.service3.b3': 'Lifespan extension',
      'services.service3.b4': 'Regular status reports',
      
      'services.service4.title': 'Audits & Optimization',
      'services.service4.desc': 'Comprehensive technical diagnostics to evaluate, identify, and improve your installations.',
      'services.service4.b1': 'Advanced technological diagnostics',
      'services.service4.b2': 'Identified sources of energy loss',
      'services.service4.b3': 'Quantified performance improvement',
      'services.service4.b4': 'Sectoral comparative analyses',
      
      'services.service5.title': 'Technical Training',
      'services.service5.desc': 'Practical training to strengthen your teams\' skills in all our areas of expertise.',
      'services.service5.b1': 'Tailor-made programs',
      'services.service5.b2': 'Practical field sessions',
      'services.service5.b3': 'Recognized certification',
      'services.service5.b4': 'Post-training support',
      
      'services.service6.title': 'Construction Planning',
      'services.service6.desc': 'Precise steering with detailed planning and total transparency at every stage.',
      'services.service6.b1': 'Optimal coordination of stakeholders',
      'services.service6.b2': 'Real-time tracking',
      'services.service6.b3': 'Proactive risk management',
      'services.service6.b4': 'Budget and deadline compliance',

      // Stats Section
      'stats.label1': 'Years of technical expertise',
      'stats.label2': 'Completed projects',
      'stats.label3': 'Team members',
      'stats.label4': 'Client satisfaction',
      'stats.marquee1': 'ELECTRICITY',
      'stats.marquee2': 'REHABILITATION',
      'stats.marquee3': 'AIR CONDITIONING',
      'stats.marquee4': 'INDUSTRIAL REFRIGERATION',
      'stats.marquee5': 'PLUMBING',
      'stats.marquee6': 'RENEWABLE ENERGIES',
      'stats.marquee7': 'CARPENTRY',
      'stats.marquee8': 'HOME AUTOMATION',

      // Expertises Section
      'expertises.tag': 'Our Areas of Expertise',
      'expertises.title1': 'Technical Excellence',
      'expertises.title2': 'At the Service of Your Projects',
      'expertises.desc': 'Complete mastery of technical packages to guarantee performance, safety, and durability for your infrastructures.',
      'expertises.learnMore': 'Learn more',
      'expertises.close': 'Close',
      'expertises.modalTitle': 'Services & Offerings',
      'expertises.quote': 'Request a quote for this service',

      // Why Choose Us
      'whyChooseUs.tag': 'Why Auxis',
      'whyChooseUs.title': 'Why Choose Us?',
      'whyChooseUs.subtitle': 'We combine technical expertise, responsiveness, and commitment to quality to guarantee the success of each intervention.',
      'whyChooseUs.contact': 'Contact Our Team',
      'whyChooseUs.learnMore': 'Learn more',
      'whyChooseUs.seeLess': 'See less',
      'whyChooseUs.reason1.title': 'Versatile Expertise',
      'whyChooseUs.reason1.desc': 'Complete solutions for all your technical needs',
      'whyChooseUs.reason1.p1': 'Multi-specialists: Electricity, plumbing, AC, carpentry, industrial refrigeration, and renewable energies',
      'whyChooseUs.reason1.p2': 'Integrated engineering offices for each domain',
      'whyChooseUs.reason2.title': 'Flexibility & Responsiveness',
      'whyChooseUs.reason2.desc': 'Available when you need them',
      'whyChooseUs.reason2.p1': 'Ability to work during non-working hours',
      'whyChooseUs.reason2.p2': '24/7 emergency response',
      'whyChooseUs.reason2.p3': 'Personalized post-installation support',
      'whyChooseUs.reason3.title': 'Guaranteed Quality',
      'whyChooseUs.reason3.desc': 'Excellence at every stage of your project',
      'whyChooseUs.reason3.p1': 'Premium materials',
      'whyChooseUs.reason3.p2': 'Quality control at every project stage',
      'whyChooseUs.reason3.p3': 'Extended warranties on installations',

      // References Section
      'references.tag': 'References',
      'references.title': 'They Trust Us',
      'references.subtitle': 'Leading companies and institutions in Madagascar.',
      'references.tagline': 'Excellence in engineering services since 2011',
      'references.about': 'About',
      'references.close': 'Close',

      'references.ref1.nom': 'United Nations',
      'references.ref1.desc': 'Service provider since 2019',
      'references.ref1.detailed': 'A service provider for the United Nations since 2019, Auxis actively contributes to building maintenance and the preservation of the organization\'s assets.',
      'references.ref1.type': 'Areas of work',
      'references.ref1.t1': 'Rapid interventions for corrective maintenance',
      'references.ref1.t2': 'Preventive maintenance',
      'references.ref1.t3': 'Design and installation',
      'references.ref1.t4': 'Renovation and interior layout',
      'references.ref1.t5': 'Monitoring and advice',

      'references.ref2.nom': 'BAMADA & SODIAMA',
      'references.ref2.desc': 'Car dealerships',
      'references.ref2.detailed': 'AUXIS acts as an electrical installer and maintenance provider in the infrastructures of these two automotive industry leaders in Madagascar.',
      'references.ref2.type': 'Achievements',
      'references.ref2.t1': 'Installation of "3 in 1" source inverter',
      'references.ref2.t2': 'Regular preventive maintenance',
      'references.ref2.t3': 'Uninterruptible power supply network - Equipment protection',

      'references.ref3.nom': 'Directorate General of Taxes',
      'references.ref3.desc': 'Premises layout',
      'references.ref3.detailed': 'Auxis took part in the installation of air conditioning systems within the DGI premises in Anosy.',
      'references.ref3.type': 'Achievement',
      'references.ref3.t1': 'Setup of a split air conditioning system in the open space',

      'references.ref4.nom': 'SOMACOU',
      'references.ref4.desc': 'Electrical designer and installer',
      'references.ref4.detailed': 'Auxis acts as an electrical designer and installer for SOMACOU.',
      'references.ref4.type': 'Achievement',
      'references.ref4.t1': 'Lightning rod installation',
      'references.ref4.t2': 'Lightning vulnerability resolution',
      'references.ref4.t3': 'Infrastructure protection',

      'contactSection.title': 'Contact Us',
      'contactSection.description': 'Get in touch with our team for any inquiry or project discussion',
      'contactSection.info.title': 'Contact Information',
      'contactSection.info.address.title': 'Address',
      'contactSection.info.address.value': 'Lot II A 28 PZ Amboditsiry, Antananarivo, Madagascar',
      'contactSection.info.phone.title': 'Phone',
      'contactSection.info.phone.value': '+261 34 08 866 86',
      'contactSection.info.email.title': 'Email',
      'contactSection.info.email.value': 'services@auxis.mg',
      'contactSection.form.title': 'Send us a message',
      'contactSection.form.name.label': 'Name',
      'contactSection.form.name.placeholder': 'Your Name',
      'contactSection.form.email.label': 'Email',
      'contactSection.form.email.placeholder': 'Your Email',
      'contactSection.form.subject.label': 'Subject',
      'contactSection.form.subject.placeholder': 'How can we help you?',
      'contactSection.form.message.label': 'Message',
      'contactSection.form.message.placeholder': 'Your Message',
      'contactSection.form.submit': 'Send Message',
      'contactSection.form.sending': 'Sending...',
      'contactSection.form.successTitle': 'Message Sent!',
      'contactSection.form.successMessage': 'Thank you for contacting us. We will get back to you as soon as possible.',

      'footer.description': 'Engineering, design and realization of specialized works: HVAC engineering, electrical engineering, fluids, and general construction.',
      'footer.navigation': 'Navigation',
      'footer.contact.title': 'Contact',
      'footer.newsletter.title': 'Stay Informed',
      'footer.newsletter.description': 'Subscribe to our newsletter to receive our latest news.',
      'footer.newsletter.placeholder': 'Your email address',
      'footer.newsletter.button': 'Subscribe',
      'footer.company.title': 'Company',
      'footer.company.about': 'About',
      'footer.company.services': 'Services',
      'footer.company.projects': 'Projects',
      'footer.company.contact': 'Contact',
      'footer.legal.title': 'Legal',
      'footer.legal.privacy': 'Privacy Policy',
      'footer.legal.terms': 'Terms of Service',
      'footer.rights': 'All rights reserved.',

      // Confidentialite
      'confidentialite.back': 'Back to home',
      'confidentialite.title': 'Privacy Policy',
      'confidentialite.updated': 'Last updated:',
      'confidentialite.s1.title': '1. Data Collection',
      'confidentialite.s1.content': 'We collect the information you provide directly to us when you use our contact form, including your name, email address, and the content of your message.',
      'confidentialite.s2.title': '2. Data Usage',
      'confidentialite.s2.content': 'The information we collect is used exclusively to:',
      'confidentialite.s2.l1': 'Respond to your inquiries or quote requests',
      'confidentialite.s2.l2': 'Improve our customer service',
      'confidentialite.s2.l3': 'Contact you regarding your project',
      'confidentialite.s3.title': '3. Data Protection',
      'confidentialite.s3.content': 'We implement a variety of security measures to maintain the safety of your personal information. Your data will not be sold, exchanged, transferred, or given to any other company without your consent.',
      'confidentialite.s4.title': '4. Contact',
      'confidentialite.s4.content': 'If you have any questions regarding this privacy policy, you may contact us at:',

      // Mentions Legales
      'mentions.back': 'Back to home',
      'mentions.title': 'Legal Mentions',
      'mentions.updated': 'Last updated:',
      'mentions.s1.title': '1. Site Publisher',
      'mentions.s1.p1': 'The website ',
      'mentions.s1.p2': ' is published by the company AUXIS.',
      'mentions.s1.siege': 'Headquarters:',
      'mentions.s1.siegeValue': 'Lot II A 28 PZ Amboditsiry, Antananarivo, Madagascar',
      'mentions.s1.email': 'Email:',
      'mentions.s1.emailValue': 'services@auxis.mg',
      'mentions.s1.tel': 'Phone:',
      'mentions.s1.telValue': '+261 34 08 866 86',
      'mentions.s2.title': '2. Intellectual Property',
      'mentions.s2.content': 'The entire site operates under Malagasy and international legislation regarding copyright and intellectual property. All reproduction rights are reserved, including downloadable documents and iconographic and photographic representations.',
      'mentions.s3.title': '3. Limitation of Liability',
      'mentions.s3.content': 'AUXIS strives to ensure, to the best of its abilities, the accuracy and updating of the information published on this site. However, AUXIS disclaims all responsibility for any imprecision, inaccuracy, or omission regarding the information available on the site.',
      'mentions.s4.title': '4. Hosting',
      'mentions.s4.content': 'This site is hosted by InMotion Hosting.',

      // Rest of the old translations
      'accueil': 'Home',
      'services': 'Services',
      'projets': 'Projects',
      'contact': 'Contact',
      'excellence': 'Excellence in',
      'ingenierie': 'Engineering & Construction',
      'solutions': 'Innovative solutions in construction, HVAC and industrial refrigeration in Madagascar.',
      'commencer': 'Get Started',
      'nosServices': 'Our Services',
      'servicesDesc': 'We offer a complete range of engineering and construction services tailored to your needs.',
      'construction': 'Construction',
      'constructionDesc': 'Innovative and sustainable construction solutions for all types of projects.',
      'climatique': 'HVAC Systems',
      'climatiqueDesc': 'High-performance and energy-efficient air conditioning and ventilation systems.',
      'industriel': 'Industrial Refrigeration',
      'industrielDesc': 'Custom industrial refrigeration solutions for businesses.',
      'nosProjets': 'Our Projects',
      'projetsDesc': 'Discover our most recent achievements and our expertise in various fields.',
      'projet': 'PROJECT',
      'projet1': 'Shopping Center',
      'projet1Desc': 'Construction and complete installation of HVAC systems.',
      'projet2': 'Industrial Site',
      'projet2Desc': 'Design and installation of industrial refrigeration systems.',
      'projet3': 'Administrative Building',
      'projet3Desc': 'Energy efficiency solutions for office buildings.',
      'contactezNous': 'Contact Us',
      'contactDesc': 'Do you have any questions? Feel free to contact us.',
      'nom': 'Name',
      'email': 'Email',
      'message': 'Message',
      'envoyer': 'Send'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;